import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ListLine } from "../framework/listLine";
import { IDocumentListItem } from "../../models/document/documentListItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { Permission } from "ui/Scripts/source/models/enums";

//DocumentListBlock
export interface IDocumentListBlockProp {
    classes?: string;
    companyId: string;
    item: IDocumentListItem;
    selected: boolean;
    favorite: boolean;
    first: boolean;
    isLastOpenedDocument: boolean;
    onClick: (id: string, companyId: string, isFolder:boolean) => void;
    onLongPress: (id: string, companyId: string) => void;
    onRefreshList: () => void;
    onRemoveFavorite: (id: string, companyId: string) => void;
}

export class DocumentListBlock extends React.Component<IDocumentListBlockProp, {}> {
    handleStopPropagation = (e) => {
        e.stopPropagation();
    };

    handleRemoveFavorite = (e) => {
        const props = this.props;
        e.stopPropagation();
        const item = props.item;
        if (!item || !props.onRemoveFavorite) return;
        props.onRemoveFavorite(item.id, props.companyId);
    };

    render() {
        const props = this.props;
        const item = props.item;
        return (
            <ListLine
                id={item.id}
                first={props.first}
                selected={props.selected}
                classes={"block" + (props.classes ? " " + props.classes : "") + (item.isFolder ? " folder" : "") + (props.favorite ? " favorite" : "") + (props.selected ? " selected" : "") + (props.isLastOpenedDocument ? " lom" : "")}
                onClick={(id: string) => { props.onClick(id, props.companyId, item.isFolder); }}
                onLongPress={props.onLongPress ? (id: string) => { props.onLongPress(id, props.companyId); } : null }
                onRefreshList={props.onRefreshList}>
                <div className="iconContainer">
                    {!item.image &&
                        <span className={"icon" + (item.isFolder ? " folder" : " file file_type_" + item.fileType)}></span>
                    }
                    {!!item.image &&
                        <img className={"icon" + (item.isFolder ? " folder" : " file")} alt="file" src={item.image} />
                    }
                    {item.isFolder && item.permission < Permission.Edit &&
                        <span className="icon lock white"></span>
                    }
                    {props.favorite &&
                        <span className={"icon star full favorite"} onClick={this.handleRemoveFavorite} onTouchStart={this.handleStopPropagation} onTouchEnd={this.handleStopPropagation} onMouseDown={this.handleStopPropagation} onMouseUp={this.handleStopPropagation} onMouseLeave={this.handleStopPropagation}></span>
                    }
                </div>
                <div className="textContainer">
                    <div>{item.code}</div>
                    {!item.isFolder &&
                        <div className="sub">{Translations.Modified + ": " + Base.timeToDateStr(item.modifyDate)}</div>
                    }
                </div>
            </ListLine>
        );
    }
}